import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import { useFlow } from "../context/FlowContext";
import useDataStore from "../store/useDataStore";
import useWidgetStore from "../store/useWidgetStore";
export default function Index(props) {
    const flow = useFlow();
    const { enabled, setEnabled } = useWidgetStore();
    const { apptypes } = useDataStore();
    // The widget boots here, on the catch-all route, and shows nothing until the apptypes have
    // landed. That wait is what makes this the place to decide which view the flow starts on:
    // the flow was configured while the apptype query was still in flight, so nothing before
    // this point can know the flow's views are ready to be resolved.
    //
    // A single apptype used to be auto-selected here, with its choice view dropped from the flow
    // entirely - removed: the backend YAML already decides how many select steps a flow gets
    // (the booking-flow-tab setting), so a one-apptype widget configured for two select steps
    // keeps both, the first just offering a single option, and the consumer picks it themselves
    // like any other choice.
    useEffect(() => {
        var _a;
        if (apptypes.length === 0)
            return;
        // restart() re-derives the valid views first, then lands on the first one that survives.
        (_a = flow.restart) === null || _a === void 0 ? void 0 : _a.call(flow);
    }, [apptypes]);
    useEffect(() => {
        if (!enabled.apptype) {
            setEnabled(Object.assign(Object.assign({}, enabled), { apptype: true }));
        }
    }, []);
    return (_jsx(_Fragment, {}));
}
